export default [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: '/home',
    meta:{
      authPosition: 2,
      authRequired: true,
      deviceRequired: false
    },
    children: [
      {
        path: 'tab/:boardId',
        name: 'root|list|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      },
      {
        path: 'tab/:boardId/:pageType',
        name: 'root|write|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      },
      {
        path: 'tab/:boardId/:pageType/:postId',
        name: 'root|write|update|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      },
      {
        path: 'tab/:boardId/:pageType',
        name: 'root|page|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      },
      {
        path: 'tab/:boardId/:pageType',
        name: 'root|excel-upload|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      },
      {
        path: 'tab/:boardId/:pageType',
        name: 'root|excel-upload-bulk|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      }
    ]
  },
  {
    path: '/project/:proj_id',
    component: () => import('@/layouts/ProjectLayout.vue'),
    meta:{
      authRequired: true
    },
    children: [
      {
        path: 'tab/:boardId',
        name: 'list|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      },
      {
        path: 'tab/:boardId/:pageType',
        name: 'write|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      },
      {
        path: 'tab/:boardId/:pageType/:postId',
        name: 'write|update|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      },
      {
        path: 'tab/:boardId/:pageType',
        name: 'page|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      },
      {
        path: 'tab/:boardId/:pageType',
        name: 'excel-upload|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      },
      {
        path: 'tab/:boardId/:pageType',
        name: 'excel-upload-bulk|tab',
        meta: {},
        component: () => import('@/views/boards/tab/Index.vue')
      }
    ]
  }
]
